import React, { Component } from "react";

import PhoneNumberButton from "../components/elements/PhoneNumberButton";
import contentPages from "../content-pages";

import "../styles/global.css";
import "../styles/page-content.css";
import "../styles/selfcity.css";
import "../styles/margin.css";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GAEventHelper from "../utils/GAEventHelper";
import ReferrerHelper from "../utils/ReferrerHelper";
import ReviewsService from "../utils/ReviewsService";
import ratings from "../assets/ratings/cumulus";
import Helmet from "react-helmet";
import NotificationHelper from "../utils/NotificationHelper";
import ContactFormModal from "../components/elements/ContactFormModal";

import CONSTANTS from "../utils/constants";
import FormButton from "../components/elements/FormButton";

export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      phoneNumber: {
        default: "",
        internationalFormat: "",
      },
      content: contentPages[props.pageReference],
      googleReviews: CONSTANTS.GOOGLE_REVIEWS,
    };
    this.slider = React.createRef();
  }

  componentDidMount() {
    const phoneNumber = new ReferrerHelper(document).getPhoneNumber();
    this.setState({ phoneNumber });

    ReviewsService()
      .fetchReviews()
      .then((res) => {
        this.setState({ googleReviews: res });
      });
  }

  onDevisButtonClick = (
    event,
    quoteRequest = { recipient: "contact", body: "" }
  ) => {
    event.preventDefault();

    let layoutPathName = window.location.pathname;
    // remove trailing slash
    layoutPathName = layoutPathName.replace(/\/$/, "");
    GAEventHelper.triggerClickEvent({
      category: CONSTANTS.GOOGLE_ANALYTICS.CATEGORIES.DEMANDE_DEVIS,
      action: CONSTANTS.GOOGLE_ANALYTICS.ACTIONS.OPEN,
      label: null,
      options: {
        window,
      },
    });

    const body = {
      type: "demande-devis",
      raw: {},
      pageReference: layoutPathName,
    };
    NotificationHelper.sendNotification(body);

    this.setState({
      showModal: true,
    });
    return;
  };

  handleOpenContactFormModal = (e, metadata = {}) => {
		e.preventDefault()
		e.stopPropagation()

		let { label } = metadata
		if (!label && e && e.currentTarget) {
			label = e.currentTarget.dataset.label
		}

		GAEventHelper.triggerClickEvent({
			category: CONSTANTS.GOOGLE_ANALYTICS.CATEGORIES.DEMANDE_DEVIS,
			action: CONSTANTS.GOOGLE_ANALYTICS.ACTIONS.OPEN,
			label: label,
			options: {
				window,
			},
		})

    window.open(
      `https://form.jotform.com/210045048049347/?token=entretien_chaudiere_selfcity`,
      { target: '_blank' }
    )

		// setShowModal(true)
		// setCurrentModalContent(null)
		// setCurrentModalLabel(label)
	}

  handleCloseContactFormModal = () => {
    this.setState({
      showModal: false,
    });
  };

  slickPrev = () => {
    this.slider.current.slickPrev();
  };
  slickNext = () => {
    this.slider.current.slickNext();
  };

  render() {
    const settings = {
      arrows: false,
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    const googleBusinessURL = process.env.GATSBY_GOOGLE_BUSINESS_URL;
    const pageReference = this.props.pageReference;
    const { content, googleReviews } = this.state;
    return (
      <main>
        <Helmet>
          <title>{content.heading.subtitle} | Selfcity Toulouse</title>
        </Helmet>

        {this.state.showModal ? (
          <ContactFormModal
            title="Demande de devis"
            onClose={this.handleCloseContactFormModal}
          />
        ) : null}

        <section className="flex">
          <div className="h1-container">
            <div className="h1-bg-img">
              <img src={content.aside.img.src} alt={content.aside.img.alt} />
            </div>
            <div className="h1">
              <div className="title">
                <img
                  src="/img/name_white_wrench_250x.png"
                  width="180px"
                  alt="Selfcity"
                />
              </div>
            </div>
          </div>
          <section className="main-section">
            <div className="title hide-sm">
              <img
                src="/img/name_black_wrench_gray_250x.png"
                width="220px"
                alt="Selfcity"
              />
            </div>
            <h1 className="subtitle">{content.heading.subtitle}</h1>
            <h4 className="subtitle-details">
              {content.heading.items.map((step, index) => {
                const icon = content.heading.icons[index];
                return (
                  <span key={index}>
                    <img src={icon.src} alt={icon.alt} width="30" />
                    {step}
                    <br />
                  </span>
                );
              })}
            </h4>

            <h2 className="section-title green ">{content.section1.title}</h2>
            <div
              className="section-content section-1"
              dangerouslySetInnerHTML={{
                __html: content.section1.text,
              }}
            />
            <div className="avis-slider-container">
              <a
                className="text-regular"
                href={googleBusinessURL}
                target="_blank"
                rel="noopener "
              >
                {googleReviews.totalReviewCount} avis Google (
                {googleReviews.averageRating}/5) :
              </a>
              <Slider ref={this.slider} {...settings}>
                {ratings.map((rating, index) => {
                  return (
                    <div key={index}>
                      <div className="avis-slider">
                        <div className="avis-client">
                          <div className="avis-photo">
                            <img
                              width="60px"
                              src={rating.imgSrc}
                              alt={rating.imgAlt}
                            />
                          </div>
                          <div className="avis-name">{rating.username}</div>
                        </div>
                        <div className="avis-content">
                          <div className="avis-rating">{rating.rating}</div>
                          <div className="avis-content-text">{rating.text}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
            <h3 className="cta hide-sm">
              {content.section1.ctaText}
              <br /> {this.state.phoneNumber.default}
            </h3>
            <h2 className="green section-title section-title-pricing">
              Démarche et tarification :{" "}
            </h2>
            <h3 className="stage-title m-t-1">Principales étapes : </h3>
            <ol className="steps-list marker-bold">
              {content.section2.steps1.map((step, index) => {
                return <li key={index}>&emsp;{step}</li>;
              })}
            </ol>
            <p> {content.section2.text1}</p>
            <h3 className="stage-title">Durée :</h3>
            <p className="m-t-0">{content.section2.text2}</p>
            <h3 className="stage-title">Tarification : </h3>
            <p className="m-t-0">{content.section2.text3}</p>
            <ol className="pricing-list marker-bold">
              {content.section2.steps3.map((step, index) => {
                return <li key={index}>&emsp;{step}</li>;
              })}
            </ol>
            <p className="bold">{content.section2.lastText}</p>
            <h3
              className="cta hide-sm"
              dangerouslySetInnerHTML={{
                __html: content.section2.ctaText,
              }}
            />
            <br />

            <h3
              className="center hide-big cta sm-last-cta "
              dangerouslySetInnerHTML={{
                __html: content.section2.ctaTextMobile,
              }}
            />
            <div className="center m-b-2">
              {pageReference ===
                CONSTANTS.CONTENT_PAGE_REFERENCES.ENTRETIEN_CHAUDIERE && (
                  <FormButton
                    text="Demander un RDV"
                    label="leftcolumn"
                    onClick={this.handleOpenContactFormModal}
                  />
              )}
            </div>
            <div className="center hide-sm">
              <PhoneNumberButton />
            </div>

            <div className="center hide-big">
              <img
                className="m-t-1"
                width="280"
                src={content.aside.img.src}
                alt={content.aside.img.alt}
              />
            </div>
          </section>
          <aside className="aside-cta">
            <img src={content.aside.img.src} alt={content.aside.img.alt} />

            <h2>{content.aside.ctaText}</h2>
            <div className="center">
              {pageReference ===
                CONSTANTS.CONTENT_PAGE_REFERENCES.ENTRETIEN_CHAUDIERE && (
                  <FormButton
                  text="Demander un RDV"
                  label="rightcolumn"
                  onClick={this.handleOpenContactFormModal}
                />
              )}
            </div>
            {pageReference !==
              CONSTANTS.CONTENT_PAGE_REFERENCES.ENTRETIEN_CHAUDIERE && (
              <PhoneNumberButton />
            )}
            <h2>
              Ou demandez votre devis par{" "}
              <a
                href="mailto:contact@selfcity.fr"
                onClick={(event) =>
                  this.onDevisButtonClick(event, content.aside.quoteRequest)
                }
              >
                email
              </a>
              .
            </h2>
          </aside>
        </section>
      </main>
    );
  }
}
